import SignatureImage from '../../assets/images/signature.png'
import DownloadIcon from '../../assets/icons/download-white.svg'
import {
  Container,
  Title,
  ParametersWrapper,
  ParametersCell,
  ParameterTitle,
  ParameterDescription,
  LabelAndDescriptionWrapper,
  Label,
  Description,
  SignatureWrapper,
  Signature,
  DigitalSignatureWrapper,
  DigitalSignatureTitle,
  DigitalSignatureValue,
  ButtonsWrapper,
  Button,
  ButtonIcon
} from './styles'

export function ReportGenerated () {
  return (
    <Container>
      <Title> Informe detallado del Retinólogo: </Title>

      <ParametersWrapper>
        <ParametersCell>
          <ParameterTitle>Paciente referible a oftalmólogo/a</ParameterTitle>
          <ParameterDescription>Si</ParameterDescription>
        </ParametersCell>

        <ParametersCell>
          <ParameterTitle>Grado de RD observada</ParameterTitle>
          <ParameterDescription>RD no proliferativa leve</ParameterDescription>
        </ParametersCell>

        <ParametersCell>
          <ParameterTitle>Sospecha de Edema Macular Diabético</ParameterTitle>
          <ParameterDescription>Moderada</ParameterDescription>
        </ParametersCell>

        <ParametersCell>
          <ParameterTitle>Se observan otras patologías concomitantes?</ParameterTitle>
          <ParameterDescription>No</ParameterDescription>
        </ParametersCell>
      </ParametersWrapper>

      <LabelAndDescriptionWrapper>
        <Label>Informe profesional extendido:</Label>
        <Description>
          <span>Se observa el caso de un paciente con Retinopatia Diabetica, potencialmente proliferativa, con hemorragias de riesgo visibles en la zona del disco optico. Se observan exudados duros en la region parafoveal, ademas de algunos microaneurismas en la zona macular. No se observan neovascularizaciones significativas, por lo que se sospecha que el riesgo de edema macular es bajo.</span>
          <span>Se recomienda consulta con especialista en patologia vitro/retinal para estudiar potencial tratamiento con laser y evitar progreso hacia edema macular.</span>
        </Description>

        <Label>Resumen para el paciente:</Label>
        <Description>
          <div>
            <span>
              <strong>Diagnostico:</strong> Retinopatia Diabetica Proliferativa con riesgo parcial de Edema Macular
            </span>

            <br />

            <span>
              <strong>Recomendacion</strong>: Asistir urgentemente a un especialista de retina/vitreo para iniciar el tratamiento.
            </span>
          </div>
        </Description>
      </LabelAndDescriptionWrapper>

      <SignatureWrapper>
        <Signature src={SignatureImage} alt='signature' />
      </SignatureWrapper>

      <DigitalSignatureWrapper>
        <DigitalSignatureTitle>Firma digital</DigitalSignatureTitle>
        <DigitalSignatureValue>7768DFDSF8DFB9GF0B75VCB433SD67DS6767SD44653221ASDF98D0934578654HKVDK67521</DigitalSignatureValue>
      </DigitalSignatureWrapper>

      <ButtonsWrapper>
        <Button type='secondary'>Ver centros de salud recomendados</Button>
        <Button type='primary'>
          <ButtonIcon src={DownloadIcon} alt='download' />
          Descargar PDF
        </Button>
      </ButtonsWrapper>
    </Container>
  )
}

export default ReportGenerated
